import React from "react";

const VideoIcon48pxSvg = ({
    color = "#6B7280",
    width = 48,
    height = 48,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path opacity="0.4" d="M35.48 15.1406C35.5 15.2806 35.5 15.4406 35.48 15.5806C35.48 15.4406 35.46 15.3006 35.46 15.1606L35.48 15.1406Z" fill={color} />
            <path d="M34.56 13.12L7.66001 40.02C4.86001 38.24 3.76001 35.06 3.76001 32V16C3.76001 9.16 6.42001 6.5 13.26 6.5H25.26C31.04 6.5 33.82 8.4 34.56 13.12Z" fill={color} />
            <path d="M42.8 4.46172C42.2 3.86172 41.22 3.86172 40.62 4.46172L3.7 41.3817C3.1 41.9817 3.1 42.9617 3.7 43.5617C4 43.8417 4.4 44.0017 4.78 44.0017C5.18 44.0017 5.56 43.8417 5.86 43.5417L42.8 6.62172C43.4 6.02172 43.4 5.06172 42.8 4.46172Z" fill={color} />
            <path d="M44.76 16.7609V31.2409C44.76 34.1009 43.36 35.2409 42.56 35.6609C42.18 35.8609 41.58 36.0809 40.84 36.0809C39.98 36.0809 38.92 35.8009 37.68 34.9209L34.72 32.8409C34.58 37.2609 33.18 39.7809 30 40.8409C28.72 41.3009 27.14 41.5009 25.24 41.5009H13.24C12.76 41.5009 12.3 41.4809 11.82 41.4209L30 23.2609L41.3 11.9609C41.82 12.0009 42.24 12.1609 42.56 12.3409C43.36 12.7609 44.76 13.9009 44.76 16.7609Z" fill={color} />
        </svg>
    );
};

export default VideoIcon48pxSvg;